import { render } from "./CustomerOrders.vue?vue&type=template&id=15dfc30c&scoped=true&ts=true"
import script from "./CustomerOrders.vue?vue&type=script&lang=ts"
export * from "./CustomerOrders.vue?vue&type=script&lang=ts"

import "./CustomerOrders.vue?vue&type=style&index=0&id=15dfc30c&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dfc30c"]])

export default __exports__